module.exports = __webpack_public_path__ + "img/belgium.d8bddc15.svg";